/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_WindowsInputs */

const en_gc_resources_download_windows = /** @type {(inputs: Gc_Resources_Download_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

const zh_gc_resources_download_windows = /** @type {(inputs: Gc_Resources_Download_WindowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows`)
};

/**
* | output |
* | --- |
* | "Windows" |
*
* @param {Gc_Resources_Download_WindowsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_windows = /** @type {((inputs?: Gc_Resources_Download_WindowsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_WindowsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_windows(inputs)
	return zh_gc_resources_download_windows(inputs)
});
export { gc_resources_download_windows as "gc.resources.download.windows" }